<template>
  <div class="mb-12">
    <div v-show="!$route.query.mobilePreview">
      <div class="editor-container relative">
        <CarouselEditor
          :jsonData="videosDetails"
          @DATA_UPDATED="previewWeb"
          @PUBLISH_DATA="saveData"
          @MOBILE_PREVIEW="triggerMobilePreview"
        />
      </div>
    </div>
    <div
      v-if="Object.keys(videosDetails).length > 0"
      id="carousel"
      class="sessions"
    >
      <YouTubeLiveSessions :videosDetails="videosDetails" />
    </div>
    <div class="text-center"></div>
  </div>
</template>

<script>
import YouTubeLiveSessions from "@edyst/shared-components/src/components/YouTubeLiveSessions"
import siteConfig from "@/utils/siteConfig"
import CarouselEditor from "@/components/YoutubeLiveSessionsEditor/CarouselEditor"

export default {
  components: {
    YouTubeLiveSessions,
    CarouselEditor,
  },
  data() {
    return {
      videosDetails: [],
    }
  },
  created() {
    let key
    if (this.$route.query.mobilePreview) {
      key = "mobile-preview-youtube-live-sessions"
    } else {
      key = "youtube-live-sessions"
    }
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}content/${key}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(res => {
        if (res.data.webinars.length === 0) {
          // populate with empty editor field, user will be able to to add new card
          this.videosDetails = [{ title: "", link: "", thumbnail: "" }]
        } else {
          this.videosDetails = res.data.webinars
        }
      })
      .catch(err => {
        this.$noty.error(
          "Something went wrong, please refer to tech team for help",
          {
            layout: "bottomLeft",
            theme: "relax",
            timeout: 2500,
          }
        )
        console.error(err)
      })
  },
  methods: {
    triggerMobilePreview(data) {
      this.postDataToBackend(
        data,
        "mobile-preview-youtube-live-sessions",
        "Mobile preview is ready."
      ).then(resStatus => {
        if (resStatus) {
          const width = window.screen.availWidth
          const height = window.screen.availHeight
          const top = height / 2 - 320
          const left = width / 2 - 180
          window.open(
            `/update-youtube-session?mobilePreview=true`,
            "_blank",
            `top=${top},left=${left},width=360,height=640`
          )
        }
      })
    },
    previewWeb(data) {
      this.videosDetails = data
    },
    saveData(data) {
      this.postDataToBackend(
        data,
        "youtube-live-sessions",
        "Successfully saved changes"
      )
    },
    postDataToBackend(data, key, message) {
      const payload = {
        webinars: data,
      }
      return this.axios({
        method: "post",
        url: `${siteConfig.siteURL}content/${key}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: payload,
      })
        .then(res => {
          if (res.status) {
            this.$noty.success(message, {
              layout: "bottomLeft",
              theme: "relax",
              timeout: 2000,
            })
            return true
          }
          return false
        })
        .catch(err => {
          this.$noty.error(
            "Failed to save changes, please refer to tech team for help",
            {
              layout: "bottomLeft",
              theme: "relax",
              timeout: 1000,
            }
          )
          console.error("Failed to save changes, server responded with", err)
          return false
        })
    },
  },
}
</script>

<style lang="postcss" scoped>
.mobile-view {
  width: 360px;
  height: 640px;
  margin: auto;
  border: 1px solid grey;
}
.btn {
  width: 200px;
  height: auto;
  margin: 10px auto;
  padding: 5px;
  border-radius: 2px;
  color: white;
  background-color: #39be70;
  text-shadow: none;
  font-weight: 500;
}
>>> .view-all-btn {
  display: inline-block;
  width: 200px;
  min-width: 200px;
  padding: 10px 35px;
  border-radius: 100px;
  color: #fff;
  background: #39be70;
  text-decoration: none;
}
</style>
